<template lang="html">
  <div>
    <div class="content" >
      <h1>Audioknihy</h1>
      <v-layout class="layout--controls">
        <v-btn
            color="secondary"
            class="button--top control"
            :href="exportLink"
            download
        >Exportovat</v-btn>
        <v-btn
          color="primary"
          type="submit"
          class="button--top control"
          @click="addAuthor()"
          >Vytvořit audioknihu</v-btn
        >
        <v-text-field
          class="input--search control"
          placeholder="Vyhledat"
          outlined
          v-model="search"
        ></v-text-field>
      </v-layout>
      <v-layout class="table-items">
        <v-data-table
          locale="cs"
          :headers="headers"
          :items="items"
          :loading="false"
          item-key="name"
          :items-per-page="perPage"
          :options.sync="options"
          :server-items-length="total"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template #progress>
            <div></div>
          </template>
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{ name: 'AudiobooksDetail', params: { id: item.id } }"
                >
                  <td class="">
                    <div
                      class="image-table image--set"
                      v-if="item.convenient_set > 0 && !item.image"
                      v-bind:class="[
                        { 'image--empty': item.set_books.length === 0 },
                        { 'image--set-1': item.set_books.length === 1 },
                        { 'image--set-2': item.set_books.length === 2 },
                        { 'image--set-3': item.set_books.length === 3 },
                        { 'image--set-4': item.set_books.length === 4 },
                        { 'image--set-5': item.set_books.length === 5 },
                      ]"
                    >
                      <div class="tag">
                        Výhodný set
                      </div>
                      <div class="image-sets" v-if="item.set_books.length > 0">
                        <div class="set-wrap" v-for="set in item.set_books">
                          <div
                            class="image__set"
                            v-if="set"
                            :style="'background-image:url(' + set + ')'"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <span
                      v-else-if="item.image"
                      class="image-table image-table--photo"
                      :style="'background-image:url(' + item.image + ')'"
                    >
                      <div class="tag" v-if="item.convenient_set > 0">
                        Výhodný set
                      </div>
                    </span>
                    <span v-else class="image-table">
                      <div class="tag" v-if="item.convenient_set > 0">
                        Výhodný set
                      </div>
                    </span>
                  </td>
                  <td class="">{{ item.sort_order }}</td>
                  <td class="">
                    <div v-if="item.is_ebook">E-kniha</div>
                    <div v-if="item.is_book">Kniha</div>
                    <div v-if="!item.is_book && !item.is_ebook">Audiokniha</div>
                  </td>
                  <td class="">{{ item.id }}</td>
                  <td class="">
                    {{ item.name }}
                    <b v-if="item.lang !== 'cs'"
                      >({{
                        langTypes.find(
                          (langType) => langType.type === item.lang
                        ).text
                      }})</b
                    >
                  </td>
                  <td class="">{{ item.slug }}</td>
                  <td class="small bold">
                    <span v-if="item.published" class="published">ANO</span>
                    <span v-else class="published published--not">NE</span>
                  </td>
                  <td class="small bold">
                    <span class="seo seo--checked" v-if="item.seo">
                      <v-icon>check</v-icon>
                    </span>
                    <span class="seo" v-else> </span>
                  </td>
                  <td class="right">
                    <v-btn color="primary" type="submit" class="button--small"
                      >Detail</v-btn
                    >
                  </td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná audiokniha nebyla nalezena</p>
              </div>
              <v-overlay
                  absolute
                  color="rgba(255, 255, 255, 0.8)"
                  :value="!loaded"
              >
                <div>
                  <div class="loader">
                    <div class="loader__item">
                    </div>
                  </div>
                </div>
              </v-overlay>
            </tbody>
          </template>

          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet audioknih na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { debounce } from 'lodash';
import moment from 'moment';

export default {
  name: 'Audiobooks',
  data() {
    return {
      langTypes: [
        {
          type: 'cs',
          text: 'Česky',
        },
        {
          type: 'sk',
          text: 'Slovensky',
        },
      ],
      json: {
        data: [],
        labels: {},
        title: 'Audioknihy',
        file: 'Audioknihy',
        meta: [
          [
            {
              key: 'charset',
              value: 'utf-8',
            },
          ],
        ],
      },
      loaded: false,
      search: '',
      headers: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: '', value: 'image', sortable: false, align: 'left' },
        { text: 'Pořadí', value: 'sort_order', align: 'left' },
        { text: 'Typ', value: 'type', align: 'left', sortable: false },
        { text: 'ID', value: 'id', align: 'left' },
        { text: 'Název', value: 'name', align: 'left' },
        { text: 'Slug', value: 'slug', align: 'left' },
        { text: 'Publikováno', value: 'published', align: 'left' },
        { text: 'SEO', value: 'seo', align: 'left' },
        { text: '', value: 'set_books_names', align: 'right' },
      ],
      items: [],
      options: {},
      total: 0,
      perPage: 30,
    };
  },

  created() {
    this.fetchData();
  },
  computed: {
    ...mapState(['profile']),
    exportLink() {
      return process.env.VUE_APP_API_BASE_URL + '/admin/audiobooks.xlsx?token=' + localStorage.getItem('token');
    },
  },
  mounted() {},
  methods: {
    addAuthor() {
      this.$router.push({ name: 'AudiobooksDetail', params: { id: 'add' } });
    },
    formatCreatedAt(date) {
      if (date) {
        return moment(date).format('D.M.YYYY - HH:mm');
      } else {
        return null;
      }
    },
    fetchData() {
      const params = {};
      if(this.options.page){
        params.page = this.options.page;
      }
      if(this.options.itemsPerPage)
      {
        params.perPage = this.options.itemsPerPage;
      }
      if(this.options.sortBy && this.options.sortBy.length > 0){
        params.sortBy = this.options.sortBy[0];
      }
      if(this.options.sortDesc && this.options.sortDesc.length > 0){
        params.order = this.options.sortDesc[0] ? 'DESC' : 'ASC';
      }
      if(this.search && this.search.length > 0){
        params.search = this.search;
      }
      this.$axios
        .get('/admin/audiobooks', { params })
        .then((response) => {
          this.items = response.data.audiobooks;
          this.total = response.data.count;
          this.loaded = true;
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
    search: debounce(function() {
      this.fetchData();
    }, 350)
  },
};
</script>

<style lang="scss"></style>
